import { useLocation } from 'react-router-dom';

import { isPaidMembershipRequiredPath } from '@/utils/membership-access';

import { usePaidMembershipAccess } from './usePaidMembershipAccess';

export const useMembershipPreviewAccess = () => {
  const location = useLocation();
  const hasPaidAccess = usePaidMembershipAccess();

  return isPaidMembershipRequiredPath(`${location.pathname}${location.search}`) && !hasPaidAccess;
};
